/**
 * Thin wrapper around @capacitor/haptics. No-op on web; silent-fail on
 * native if the plugin isn't installed/initialized.
 */
import { Capacitor } from "@capacitor/core";

export type HapticIntent =
  | "tab-switch"
  | "primary-action"
  | "selection"
  | "success";

export async function triggerHaptic(intent: HapticIntent): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    const { Haptics, ImpactStyle, NotificationType } = await import(
      "@capacitor/haptics"
    );

    switch (intent) {
      case "tab-switch":
        await Haptics.impact({ style: ImpactStyle.Light });
        break;
      case "primary-action":
        await Haptics.impact({ style: ImpactStyle.Medium });
        break;
      case "selection":
        await Haptics.selectionChanged();
        break;
      case "success":
        await Haptics.notification({ type: NotificationType.Success });
        break;
    }
  } catch {
    // Haptics are non-essential — fail silently.
  }
}
